import React, { Fragment, useEffect } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';

import circleDeclined from 'assets/icons/circle-declined.svg';

import style from './style.scss';

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get('key')) {
      navigate(`/applications/${params.workflowtype}/application`);
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-message'])}>
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">
            <div className="cell small-12 large-8 large-offset-2">
              <img src={circleDeclined} alt="Circle Declined" />
              <h2>{location.state ? location.state.message : 'Internal server error'}</h2>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default ErrorPage;
